// eslint-disable-next-line no-mixed-operators
const map = (x, inMin, inMax, outMin, outMax) => ((x - inMin) * (outMax - outMin) / (inMax - inMin) + outMin);

export default map;
